<template>
  <alert-box type="danger" :closable="false" :show-icon="false">
    {{ $label("common.not_found", "Not found") }}
  </alert-box>
</template>

<script>
import AlertBox from "@/components/Common/Alerts/AlertBox";

export default {
  components: { AlertBox }
};
</script>
